// extracted by mini-css-extract-plugin
export default {"brandCodeContainer":"styles_brandCodeContainer__eowRi"};